var i18n = require('i18n');
var util = require('./util');

///*
var highlight = require('../../node_modules/highlight.js/lib/highlight.js');
highlight.registerLanguage('javascript', require('../../node_modules/highlight.js/lib/languages/javascript'));
highlight.registerLanguage('sql', require('../../node_modules/highlight.js/lib/languages/sql'));
highlight.registerLanguage('css', require('../../node_modules/highlight.js/lib/languages/css'));
highlight.registerLanguage('shell', require('../../node_modules/highlight.js/lib/languages/shell'));
highlight.registerLanguage('html', require('../../node_modules/highlight.js/lib/languages/xml'));
//*/

//var highlight = require('highlight.js');
var map = {
  javascript: 1,
  sql: 1,
  css: 1,
  shell: 1,
  html: 1
}

var marked = require('markdown-it')({
  highlight: function (code, language) {
    if (language && !map[language]) {
      return `<pre><code class="hljs ${language}"></code></pre>`
    }
    language = language || 'javascript';
    code = highlight.getLanguage(language) ? highlight.highlight(language, code).value : code;
    // 下面的 html 不要换行  
    return `<pre><code class="hljs ${language}">${code}</code></pre>`;
  }
});

var pageConfig = window.pageConfig;
if (pageConfig.topic && pageConfig.topic.editorType === 'markdown') {
  pageConfig.markdown = pageConfig.topic.content;
  pageConfig.markdown = pageConfig.markdown.replace(new RegExp('&lt;/script>', 'gm'), '</script>')
  pageConfig.topic.content = marked.render(pageConfig.markdown);
}

$('body').append(`<div class="markdown-preview markdown-body">
  <div class="preview-content"></div>
  <div class="close">&times</div>
</div>`);

$(document).on('change', '.markdown-layer .upload-file', function () {
  var file = this.files[0];
  if (file.size > window.enhancerMaxFileSize) {
    util.show(i18n('fileSize'), 'warning');
    return
  }
  var url = window.URL.createObjectURL(this.files[0]); 
  var layer = $(this).closest('.markdown-layer');
  var editor = layer.find('.markdown-editor');
  var cursorPos = layer.data('cursorPos') || 0;

  var v = editor.val();
  var textBefore = v.substring(0,  cursorPos);
  var textAfter  = v.substring(cursorPos, v.length);

  editor.val(`${textBefore}![](${url})${textAfter}`);
});

$(document).on('click', '.markdown-layer .upload-pic', function() {
	var layer = $(this).closest('.markdown-layer');
	var editor = layer.find('.markdown-editor');
	layer.data('cursorPos', editor.prop('selectionStart'));
	layer.find('.upload-file').click();
});

$(document).on('click', '.markdown-layer .preview', function () {
	var layer = $(this).closest('.markdown-layer');
  var editor = layer.find('.markdown-editor');
  var src = editor.val();
  var markdown = marked.render(src);
  $('.markdown-preview .preview-content').html(markdown)
  $('.markdown-preview').show();
});

$('.markdown-preview .close').click(function () {
  $('.markdown-preview').hide();
});


$('body').on('paste', '.markdown-editor', function (e) {
    var items = (e.clipboardData || e.originalEvent.clipboardData).items;
    for (var index in items) {
      var item = items[index];
      if (item.type === 'image/png') {
        var blob = item.getAsFile();
        if (blob.size > window.enhancerMaxFileSize) {
          var size = window.enhancerMaxFileSize / (1024*1024);
          util.show(i18n('file.size', {size: size}))
          return
        }
        var url = window.URL.createObjectURL(blob);
        var layer = $(this).closest('.markdown-layer');
        var editor = layer.find('.markdown-editor');
        var cursorPos = layer.data('cursorPos') || editor.prop('selectionStart') || 0;

        var v = editor.val();
        var textBefore = v.substring(0,  cursorPos);
        var textAfter  = v.substring(cursorPos, v.length);

        editor.val(`${textBefore}![](${url})${textAfter}`);
      }
    }
  });




module.exports = marked;




// WEBPACK FOOTER //
// ./src/app/markdown.js